import { proposal as constants } from "store/constants";
import { reduceIsFetching, fetchableInitialState } from "store/factories/fetchable";


const initialState = {
	content: {
		proposal: {
			...fetchableInitialState,
			reviewEvents: [],
			adminTeamMembers: [],
			userAccesses: [],
			certificationEvents: [],
		},
		formSections: {},
		values: {
			...fetchableInitialState,
			data: {},
		},
	},
};

export function proposal(state = initialState, action) {
	switch (action.type) {
		case constants.SINGLE_PROPOSAL_IS_FETCHING:
			return {
				...state,
				content: {
					...state.content,
					proposal: reduceIsFetching(state.content.proposal, action),
				},
			};
		case constants.SINGLE_PROPOSAL_SET_ERROR:
			return {
				...state,
				content: {
					...state.content,
					proposal: {
						...state.content.proposal,
						error: action.payload,
					},
				},
			};
		case constants.SINGLE_PROPOSAL_SET_DATA:
			return {
				...state,
				content: {
					...state.content,
					...action.payload,
				},
			};

		case constants.SINGLE_PROPOSAL_VALUES_IS_FETCHING:
			return {
				...state,
				content: {
					...state.content,
					values: reduceIsFetching(state.content.values, action),
				},
			};
		case constants.SINGLE_PROPOSAL_VALUES_SET_ERROR:
			return {
				...state,
				content: {
					...state.content,
					values: {
						...state.content.values,
						error: action.payload,
					},
				},
			};
		case constants.SINGLE_PROPOSAL_VALUES_SET_DATA:
			return {
				...state,
				content: {
					...state.content,
					values: {
						...state.content.values,
						data: action.payload,
					},
				},
			};
		case constants.RESET:
			return initialState;

		default:
			return state;
	}
}
